import { render } from "./GalleryWidget.vue?vue&type=template&id=0cefd9d5"
import script from "./GalleryWidget.vue?vue&type=script&lang=js"
export * from "./GalleryWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__